import pathToRegexp from 'path-to-regexp';

import { entityPathMap as menusEntityPathMap } from 'menus/constants/paths';
import { entityPathMap as locationsEntityPathMap } from 'locations/constants/paths';
import { entityPathMap as cartEntityPathMap } from 'cart/constants/paths';

const globalEntityMap = {
  ...menusEntityPathMap,
  ...locationsEntityPathMap,
  ...cartEntityPathMap
};

/*
  generatePath retrieves raw path names from the globalEntityPathMap based on the entity and pathType
  provided.  If named parameters are passed in, it will inject these to create a final, formatted path.
  For example:
    generatePath(USER, 'detail', {resource: 23}) => '/users/23'
    generatePath(USER, 'list') => '/users'
  To use, entity paths must be imported above into the globalEntityPathMap object.
  Parameters:
  - entity (string) required - type of object related to actions to retrieve
  - pathType (string) required - type of path to genereate (e.g., 'list' or 'detail')
  - namedParameters (object) optional - defaults to null - the namedParameters to inject into the raw path.
 */
export function generatePath(entity, pathType, namedParameters) {
  const entityMap = globalEntityMap[entity];
  if (!entityMap) {
    throw new Error(
      `Can't find path for entity ${pathType}. Did you import the ${pathType}?`
    );
  }

  const entityPath = entityMap[pathType];
  if (!entityPath) {
    throw new Error(
      `Can't find path for entity ${entityPath}. Did you define the modal path in the path file?`
    );
  }

  if (!namedParameters && entityPath.indexOf(':') > -1) {
    throw new Error(
      `Path ${entityPath} requires a namedParameters object to be passed into generatePath.`
    );
  }

  if (namedParameters) {
    // Ensure all params are strings.
    const formattedParams = Object.keys(namedParameters).reduce(
      (acc, param) => {
        acc[param] = namedParameters[param].toString();
        return acc;
      },
      {}
    );

    const toPath = pathToRegexp.compile(entityPath);
    return toPath(formattedParams);
  }

  return entityPath;
}
